var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMozambique(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_740)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 39.9999C31.0459 39.9999 40.0003 31.0456 40.0003 19.9999C40.0003 8.95424 31.0459 -6.10352e-05 20.0002 -6.10352e-05C8.95455 -6.10352e-05 0.000244141 8.95424 0.000244141 19.9999C0.000244141 31.0456 8.95455 39.9999 20.0002 39.9999Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8104 27.826L5.85864 34.1414C9.4777 37.761 14.4772 40 20.0001 40C28.2681 40 35.3629 34.9821 38.4088 27.826H10.8104Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4399 12.2463C35.4111 5.05166 28.2961 -6.10352e-05 20.0001 -6.10352e-05C14.4772 -6.10352e-05 9.47771 2.23892 5.85864 5.85845L10.8672 12.2463H38.4399Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.34784 14.7101V25.2173H39.3111C39.7597 23.554 40 21.8052 40 20C40 18.1686 39.7533 16.3951 39.2921 14.7101H4.34784Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.85791 5.85779C-1.95256 13.6683 -1.95256 26.3316 5.85791 34.1422C9.08549 30.9146 12.1896 27.8104 20.0001 20L5.85791 5.85779Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.0945 14.7825L9.38942 18.7682H13.5805L10.19 21.2316L11.4849 25.2174L8.0945 22.754L4.70395 25.2174L5.99911 21.2316L2.60864 18.7682H6.79942L8.0945 14.7825Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.30518 19.9999H11.8852V23.4782H4.30518V19.9999Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3204 16.0124L12.0907 14.7825L8.09472 18.7785L4.09878 14.7825L2.86902 16.0124L6.86847 20.0047L2.86902 24.0043L4.09878 25.2174L8.09472 21.2286L12.0907 25.2174L13.3204 24.0043L9.32097 20.0047L13.3204 16.0124Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_740"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMozambique);
export default __webpack_public_path__ + "static/media/mozambique.07febb9f5b883ecdf9ab26fdf6615888.svg";
export { ForwardRef as ReactComponent };